import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialPinterest = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M8.26 17.987c-.248 1.139-.024 3.747-.024 3.747l.723.266s1.246-2.26 1.523-3.4l.732-2.984c.383.78 1.5 1.443 2.691 1.443 3.544 0 6.095-3.483 6.095-7.81C20 5.104 16.833 2 12.76 2 7.69 2 5 5.636 5 9.597c0 1.84.916 4.133 2.383 4.862.223.111.341.062.393-.167.039-.175.237-1.027.327-1.424a.4.4 0 0 0-.082-.36c-.485-.63-.874-1.786-.874-2.865 0-2.77 1.962-5.448 5.302-5.448 2.886 0 4.907 2.1 4.907 5.107 0 3.397-1.605 5.75-3.692 5.75-1.153 0-2.016-1.02-1.74-2.27.332-1.492.974-3.102.974-4.18 0-.963-.484-1.767-1.487-1.767-1.179 0-2.124 1.303-2.124 3.048 0 1.112.35 1.864.35 1.864s-1.164 5.26-1.377 6.24Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialPinterest) as SvgIcon;
export { ForwardRef as ReactComponent };
